import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext";
import Testata from "./partials/Testata";
import Footer from "./partials/Footer";
import InputMask from 'react-input-mask';

function NuovoAnnuncio() {
  const { userData } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); 
  const [fileError, setFileError] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); 
  const [codiceFiscaleCount, setCodiceFiscaleCount] = useState(0); // Stato per il conteggio dei codici fiscali
  const [codiceFiscaleError, setCodiceFiscaleError] = useState(null); // Stato per l'errore di validazione del codice fiscale
  const [isSubmitting, setIsSubmitting] = useState(false); // Stato per il submit
  const navigate = useNavigate();
  const [provinceFiltrate, setProvinceFiltrate] = useState([]);
  // Definizione della funzione fetchCliente FUORI da useEffect
  // const [regione, setRegione] = useState(null);
  // const [prov, setProv] = useState(null);
  // const [textAreaValue, setTextAreaValue] = useState("");
  const maxChars = 1000;
  const [formData, setFormData] = useState({
  id_utente: userData?.id || "", // Aggiungiamo id_utente se necessario per il nuovo annuncio
  nome: "",
  cognome: "",
  codfisc: "",
  age: "",
  nato: "",    // Formato YYYY-MM-DD per input type="date"
  natoA: "",
  decesso: "", // Formato YYYY-MM-DD per input type="date"
  mortoA: "",
  coniuge: "",
  comune: "",
  regione: "", // Inizializzato a stringa vuota
  prov: "",    // Inizializzato a stringa vuota
  cap: "",
  funerale: "",
  cimitero: "",
  testo: "",
  filename: "", // Per il nome del file immagine caricato
  cosa: "Necrologio", // Valore di default o campo da gestire
  img: "" // Se gestisci un path per l'immagine esistente (non tipico per NuovoAnnuncio)
});

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      // Se userData ha regione/prov, usa quelli (in MAIUSCOLO),
      // altrimenti mantieni quelli già in formData (che saranno "" dall'init o valori precedenti)
      regione: userData?.regione ? userData.regione.toUpperCase() : prevFormData.regione,
      prov: userData?.prov ? userData.prov.toUpperCase() : prevFormData.prov,
      // Se id_utente deve venire da userData e non è già nell'initial formData
      id_utente: userData?.id || prevFormData.id_utente || "",
    }));
  }, [userData]);
  
  const province = [
  // ABRUZZO
  { sigla: 'CH', nome: 'Chieti', regioneNomeEsteso: 'ABRUZZO' },
  { sigla: 'AQ', nome: 'L\'Aquila', regioneNomeEsteso: 'ABRUZZO' },
  { sigla: 'PE', nome: 'Pescara', regioneNomeEsteso: 'ABRUZZO' },
  { sigla: 'TE', nome: 'Teramo', regioneNomeEsteso: 'ABRUZZO' },
  // BASILICATA
  { sigla: 'MT', nome: 'Matera', regioneNomeEsteso: 'BASILICATA' },
  { sigla: 'PZ', nome: 'Potenza', regioneNomeEsteso: 'BASILICATA' },
  // CALABRIA
  { sigla: 'CZ', nome: 'Catanzaro', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'CS', nome: 'Cosenza', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'KR', nome: 'Crotone', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'RC', nome: 'Reggio Calabria', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'VV', nome: 'Vibo Valentia', regioneNomeEsteso: 'CALABRIA' },
  // CAMPANIA
  { sigla: 'AV', nome: 'Avellino', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'BN', nome: 'Benevento', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'CE', nome: 'Caserta', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'NA', nome: 'Napoli', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'SA', nome: 'Salerno', regioneNomeEsteso: 'CAMPANIA' },
  // EMILIA ROMAGNA (o EMILIA-ROMAGNA, basato sulla tua formattazione precedente)
  { sigla: 'BO', nome: 'Bologna', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'FE', nome: 'Ferrara', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'FC', nome: 'Forlì-Cesena', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'MO', nome: 'Modena', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'PR', nome: 'Parma', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'PC', nome: 'Piacenza', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'RA', nome: 'Ravenna', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'RE', nome: 'Reggio Emilia', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'RN', nome: 'Rimini', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  // FRIULI VENEZIA GIULIA (attenzione alla virgola se presente nel tuo array regioni)
  { sigla: 'GO', nome: 'Gorizia', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  { sigla: 'PN', nome: 'Pordenone', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  { sigla: 'TS', nome: 'Trieste', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  { sigla: 'UD', nome: 'Udine', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  // LAZIO
  { sigla: 'FR', nome: 'Frosinone', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'LT', nome: 'Latina', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'RI', nome: 'Rieti', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'RM', nome: 'Roma', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'VT', nome: 'Viterbo', regioneNomeEsteso: 'LAZIO' },
  // LIGURIA
  { sigla: 'GE', nome: 'Genova', regioneNomeEsteso: 'LIGURIA' },
  { sigla: 'IM', nome: 'Imperia', regioneNomeEsteso: 'LIGURIA' },
  { sigla: 'SP', nome: 'La Spezia', regioneNomeEsteso: 'LIGURIA' },
  { sigla: 'SV', nome: 'Savona', regioneNomeEsteso: 'LIGURIA' },
  // LOMBARDIA
  { sigla: 'BG', nome: 'Bergamo', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'BS', nome: 'Brescia', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'CO', nome: 'Como', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'CR', nome: 'Cremona', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'LC', nome: 'Lecco', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'LO', nome: 'Lodi', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'MN', nome: 'Mantova', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'MI', nome: 'Milano', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'MB', nome: 'Monza e della Brianza', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'PV', nome: 'Pavia', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'SO', nome: 'Sondrio', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'VA', nome: 'Varese', regioneNomeEsteso: 'LOMBARDIA' },
  // MARCHE
  { sigla: 'AN', nome: 'Ancona', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'AP', nome: 'Ascoli Piceno', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'FM', nome: 'Fermo', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'MC', nome: 'Macerata', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'PU', nome: 'Pesaro e Urbino', regioneNomeEsteso: 'MARCHE' },
  // MOLISE (attenzione allo spazio se presente nel tuo array regioni)
  { sigla: 'CB', nome: 'Campobasso', regioneNomeEsteso: 'MOLISE ' },
  { sigla: 'IS', nome: 'Isernia', regioneNomeEsteso: 'MOLISE ' },
  // PIEMONTE
  { sigla: 'AL', nome: 'Alessandria', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'AT', nome: 'Asti', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'BI', nome: 'Biella', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'CN', nome: 'Cuneo', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'NO', nome: 'Novara', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'TO', nome: 'Torino', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'VB', nome: 'Verbano-Cusio-Ossola', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'VC', nome: 'Vercelli', regioneNomeEsteso: 'PIEMONTE' },
  // PUGLIA
  { sigla: 'BA', nome: 'Bari', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'BT', nome: 'Barletta-Andria-Trani', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'BR', nome: 'Brindisi', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'FG', nome: 'Foggia', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'LE', nome: 'Lecce', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'TA', nome: 'Taranto', regioneNomeEsteso: 'PUGLIA' },
  // SARDEGNA
  { sigla: 'CA', nome: 'Cagliari', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'NU', nome: 'Nuoro', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'OR', nome: 'Oristano', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'SS', nome: 'Sassari', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'SU', nome: 'Sud Sardegna', regioneNomeEsteso: 'SARDEGNA' }, // Provincia del Sud Sardegna
  // SICILIA
  { sigla: 'AG', nome: 'Agrigento', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'CL', nome: 'Caltanissetta', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'CT', nome: 'Catania', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'EN', nome: 'Enna', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'ME', nome: 'Messina', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'PA', nome: 'Palermo', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'RG', nome: 'Ragusa', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'SR', nome: 'Siracusa', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'TP', nome: 'Trapani', regioneNomeEsteso: 'SICILIA' },
  // TOSCANA
  { sigla: 'AR', nome: 'Arezzo', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'FI', nome: 'Firenze', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'GR', nome: 'Grosseto', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'LI', nome: 'Livorno', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'LU', nome: 'Lucca', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'MS', nome: 'Massa-Carrara', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'PI', nome: 'Pisa', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'PT', nome: 'Pistoia', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'PO', nome: 'Prato', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'SI', nome: 'Siena', regioneNomeEsteso: 'TOSCANA' },
  // TRENTINO-ALTO ADIGE
  { sigla: 'BZ', nome: 'Bolzano/Bozen', regioneNomeEsteso: 'TRENTINO ALTO ADIGE' },
  { sigla: 'TN', nome: 'Trento', regioneNomeEsteso: 'TRENTINO ALTO ADIGE' },
  // UMBRIA
  { sigla: 'PG', nome: 'Perugia', regioneNomeEsteso: 'UMBRIA' },
  { sigla: 'TR', nome: 'Terni', regioneNomeEsteso: 'UMBRIA' },
  // VALLE D'AOSTA (o VAL D'AOSTA, attenzione all'apostrofo)
  { sigla: 'AO', nome: 'Aosta', regioneNomeEsteso: 'VALLE D\'AOSTA' },
  // VENETO
  { sigla: 'BL', nome: 'Belluno', regioneNomeEsteso: 'VENETO' },
  { sigla: 'PD', nome: 'Padova', regioneNomeEsteso: 'VENETO' },
  { sigla: 'RO', nome: 'Rovigo', regioneNomeEsteso: 'VENETO' },
  { sigla: 'TV', nome: 'Treviso', regioneNomeEsteso: 'VENETO' },
  { sigla: 'VE', nome: 'Venezia', regioneNomeEsteso: 'VENETO' },
  { sigla: 'VR', nome: 'Verona', regioneNomeEsteso: 'VENETO' },
  { sigla: 'VI', nome: 'Vicenza', regioneNomeEsteso: 'VENETO' },
];
  const regioni = [
    { sigla: 'ABRUZZO', nome: 'ABRUZZO' },
    { sigla: 'BASILICATA', nome: 'BASILICATA' },
    { sigla: 'CALABRIA', nome: 'CALABRIA' },
    { sigla: 'CAMPANIA', nome: 'CAMPANIA' },
    { sigla: 'EMILIA ROMAGNA', nome: 'EMILIA ROMAGNA' },
    { sigla: 'FRIULI VENEZIA GIULIA,', nome: 'FRIULI VENEZIA GIULIA,' },
    { sigla: 'LAZIO', nome: 'LAZIO' },
    { sigla: 'LIGURIA', nome: 'LIGURIA' },
    { sigla: 'LOMBARDIA', nome: 'LOMBARDIA' },
    { sigla: 'MARCHE', nome: 'MARCHE' },
    { sigla: 'MOLISE', nome: 'MOLISE' },
    { sigla: 'PIEMONTE', nome: 'PIEMONTE' },
    { sigla: 'PUGLIA', nome: 'PUGLIA' },
    { sigla: 'SARDEGNA', nome: 'SARDEGNA' },
    { sigla: 'SICILIA', nome: 'SICILIA' },
    { sigla: 'TOSCANA', nome: 'TOSCANA' },
    { sigla: 'TRENTINO ALTO ADIGE', nome: 'TRENTINO ALTO ADIGE' },
    { sigla: 'UMBRIA', nome: 'UMBRIA' },
    { sigla: 'VENETO', nome: 'VENETO' },
    { sigla: 'VALLE D\'AOSTA', nome: 'VALLE D\'AOSTA' },
  ];
  useEffect(() => {
    if (formData.regione) {
      const provinceDellaRegione = province.filter(
        (provItem) => provItem.regioneNomeEsteso === formData.regione
      );
      setProvinceFiltrate(provinceDellaRegione);
    } else {
      setProvinceFiltrate([]);
    }
  }, [formData.regione]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    // Resetta l'errore all'inizio
    setFileError(null); 

    if (file) {
      console.log("fileError prima dei controlli:", fileError);
      // Ottieni l'estensione del file con split()
      const fileExtension = file.name.split('.').pop().toLowerCase(); 

      const allowedExtensions = ["jpg", "jpeg", "png"];
      if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
        setFileError("Attenzione!!! Solo JPG, JPEG e PNG di 2 Mb. al massimo.");
        setSelectedFile(null);
        // return; // NON uscire dalla funzione qui
      }

      // Controlla la dimensione del file (2 MB)
      if (file.size > 2 * 1024 * 1024) { 
        setFileError("Attenzione!!! Solo JPG, JPEG e PNG di 2 Mb. al massimo.");
        setSelectedFile(null);
        // return; // NON uscire dalla funzione qui
      }

      // Sposta il log qui, DOPO tutti i controlli
      console.log("fileError dopo i controlli:", fileError); 

      setFormData((prevFormData) => ({
        ...prevFormData,
        filename: file.name
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        filename: ''
      }));
    }
  };
  
  const handleChange = (e) => {
    const { name, value, type } = e.target; // AGGIUNTO 'type'
    let processedValue;

    if (type === "date" || type === "number") {
      processedValue = value;
    } else if (typeof value === 'string') {
      processedValue = value.toUpperCase();
    } else {
      processedValue = value; // Per altri tipi come checkbox (se presenti)
    }

    if (name === "regione") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        regione: processedValue, // Già MAIUSCOLO
        prov: "", // Resetta la provincia
      }));
    } else if (name === "testo") {
      // Controllo maxChars sulla lunghezza del valore originale
      if (value.length <= maxChars) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: processedValue, // Salva il valore maiuscolo
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: processedValue,
      }));
    }
  };

  // Funzione per validare il formato del codice fiscale
  const validateCodiceFiscale = (codiceFiscale) => {
    const regex = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
    return regex.test(codiceFiscale);
  };

  // useEffect per controllare il codice fiscale quando cambia
  useEffect(() => {
    let isMounted = true; // Flag per evitare memory leak
    const checkCodiceFiscale = async () => {
      if (formData.codfisc) { // Controlla se il campo non è vuoto
        // Verifica il formato del codice fiscale
        if (!validateCodiceFiscale(formData.codfisc)) {
          if (isMounted) { 
            setCodiceFiscaleError("Il codice fiscale inserito non è valido.");
          }
          return;
        } else {
          if (isMounted) {
            setCodiceFiscaleError(null);
          }
        }

        try {
          const response = await fetch(`/api/check-codice-fiscale/${formData.codfisc}`);
          if (response.ok) {
            const data = await response.json();
            if (isMounted) { // Aggiorna lo stato solo se il componente è ancora montato
              setCodiceFiscaleCount(data.count);
            }
          } else {
            console.error("Errore durante il controllo del codice fiscale");
          }
        } catch (err) {
          console.error("Errore durante il controllo del codice fiscale:", err);
        }
      } else {
        if (isMounted) { // Resetta il conteggio se il campo è vuoto
          setCodiceFiscaleCount(0);
        }
      }
    };

    checkCodiceFiscale();

    return () => { isMounted = false; }; // Cleanup function
  }, [formData.codfisc]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Imposta lo stato di submit a true

    // Verifica se il codice fiscale è valido prima di inviare il form
    if (!validateCodiceFiscale(formData.codfisc)) {
      alert("Il codice fiscale inserito non è valido.");
      setIsSubmitting(false); // Resetta lo stato di submit
      return;
    }
    if (codiceFiscaleCount >= 2) {
      alert("Codice fiscale già presente 2 o più volte nel database.");
      setIsSubmitting(false); // Resetta lo stato di submit
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const formDataToSend = new FormData();
      for (const key in formData) {
        if (key !== 'file') { // Salta il campo 'file' nel ciclo
          formDataToSend.append(key, formData[key]);
        }
      }
      if (selectedFile) { 
        formDataToSend.append('file', selectedFile);
      } 
      const response = await fetch(`/api/nuovo-annuncio`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Cache-Control': 'no-cache'
        },
        credentials: 'include',
        body: formDataToSend
      });
      
      if (response.ok) {
        setShowSuccessMessage(true);
        // Nascondi il messaggio dopo un breve ritardo (opzionale)
        setTimeout(() => {
            setShowSuccessMessage(false);
        }, 3000); // Nascondi dopo 3 secondi
        setTimeout(() => {
            navigate('/dashboard'); // Reindirizza alla dashboard dopo il salvataggio
        }, 3100);
        } else {
        const errorData = await response.json();
        setError(errorData.error || 'Errore durante il salvataggio');
      }
    } catch (error) {
      console.error('Errore durante il caricamento:', error);
      if (error.message.includes('Formato del file non valido')) {
        setFileError('Attenzione!!! Sono ammessi solo JPG, JPEG e PNG di 2 Mb. al massimo.');
      } else if (error.message.includes('File troppo grande')) {
        setFileError('Attenzione!!! Sono ammessi solo JPG, JPEG e PNG di 2 Mb. al massimo.');
      } else if (error.message.includes('Codice fiscale già presente')) {
        // Gestisci l'errore del codice fiscale
      } else {
        alert('Si è verificato un errore sconosciuto durante il caricamento: ricarica la pagina e riprova.');
      }
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <section className="main_content dashboard_part">
        <div className='className="container-fluid g-0'>            
            <Testata userData={userData} />
        </div>
        <div className="main_content_iner ">
          <div className="container-fluid plr_30 body_white_bg pt_30">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="white_box_tittle list_header">
                  <h4><a href="/dashboard"><i className="ti-arrow-circle-left" style={{fontSize: '0.8rem'}}></i> Indietro</a> &nbsp; | &nbsp; Nuovo Annuncio</h4>                  
                </div>
                {error && <p className="error-message">{error}</p>}
                  <form onSubmit={handleSubmit}>
                    <div className="col-12 mb_30">
                      <div className="row">
                        <div className="form-group col-md-2 cols-sm-6 mb_30">
                            <label htmlFor="codfisc">
                                Codice Fiscale del Defunto <b className="text text-danger">*</b>:
                            </label>
                            <InputMask
                              mask="aaaaaa99a99a999a" // Z=a (lettera), X=9 (numero)
                              maskChar={null} // O usa '_' se preferisci un placeholder visibile nella maschera
                              alwaysShowMask={false} // Mostra la maschera solo on focus o se c'è valore
                              className="form-control"
                              id="codfisc"
                              name="codfisc"
                              value={formData.codfisc} // Il valore viene da formData
                              onChange={handleChange}  // La tua handleChange gestirà l'aggiornamento e toUpperCase
                              required
                              aria-required="true"
                            />
                            {codiceFiscaleError && (
                                <p style={{fontWeight: "400", fontSize: "0.7rem", color: "#CC0000"}}>{codiceFiscaleError}</p>
                            )}
                            {codiceFiscaleCount >= 2 && (
                                <p style={{fontWeight: "500", color: "#CC0000"}}>
                                Codice fiscale già presente 2 volte.
                                </p>
                            )}
                        </div>
                        <div className="form-group col-md-2 cols-sm-6 mb_30">
                            <label htmlFor="codfisc">
                                Di anni:
                            </label>
                            <input type="number" className="form-control" id="age" name="age" value={formData.age} onChange={handleChange} />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="nome">Nome del Defunto<b className="text text-danger">*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nome"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                                required
                                aria-required="true"
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="cognome">Cognome del Defunto<b className="text text-danger">*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cognome"
                                name="cognome"
                                value={formData.cognome}
                                onChange={handleChange}
                                required
                                aria-required="true"
                            />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="indirizzo">Nato il:</label>
                            <input
                                type="date" 
                                className="form-control"
                                id="nato"
                                name="nato"
                                value={formData.nato}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="indirizzo">Nato a:</label>
                            <input
                                type="text" 
                                className="form-control"
                                id="natoA"
                                name="natoA"
                                value={formData.natoA}
                                onChange={handleChange}
                            />
                        </div> 
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="indirizzo">Deceduto il<b className="text text-danger">*</b>:</label>
                            <input
                                type="date" 
                                className="form-control"
                                id="decesso"
                                name="decesso"
                                value={formData.decesso}
                                onChange={handleChange}
                                required
                                aria-required="true"
                            />
                        </div> 
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="indirizzo">Deceduto a:</label>
                            <input
                                type="text" 
                                className="form-control"
                                id="mortoA"
                                name="mortoA"
                                value={formData.mortoA}
                                onChange={handleChange}
                            />
                        </div>                      

                        <div className="form-group col-md-4 col-sm-12 mb_20">
                          <label htmlFor="indirizzo">Nominativo del Coniuge:</label>
                          <input
                            type="text" 
                            className="form-control"
                            id="coniuge"  
                            name="coniuge"
                            value={formData.coniuge}  
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row">                        
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                          <label htmlFor="regione">Regione di residenza del Defunto <b className="text text-danger">*</b>:</label>
                          <select
                            className="form-select form-control"
                            id="regione"
                            name="regione"
                            value={formData.regione || ""} // Assicura valore controllato
                            onChange={handleChange}
                            required
                            aria-required="true"
                          >
                            <option value="">Seleziona Regione</option> {/* AGGIUNTO PLACEHOLDER */}
                            {regioni.map(reg => (
                              <option key={reg.sigla} value={reg.sigla}> {/* reg.sigla è già MAIUSCOLO */}
                                {reg.nome} {/* reg.nome è già MAIUSCOLO */}
                              </option>
                            ))}
                          </select>
                          </div>
                          <div className="form-group col-md-2 cols-sm-6 mb_20">
                              <label htmlFor="prov">Prov: <b className="text text-danger">*</b></label>
                              <select
                                className="form-select form-control"
                                id="prov"
                                name="prov"
                                value={formData.prov || ""} // Assicura valore controllato
                                onChange={handleChange}
                                disabled={!formData.regione}
                                required={!!formData.regione}
                                aria-required="true"
                              >
                                <option value="">Seleziona Provincia</option> {/* AGGIUNTO PLACEHOLDER */}
                                {provinceFiltrate.map(p => (
                                  <option key={p.sigla} value={p.sigla.toUpperCase()}>
                                    {p.nome}
                                  </option>
                                ))}
                              </select>
                          </div>
                          <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="comune">Comune di residenza del Defunto<b className="text text-danger">*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="comune"
                                name="comune"
                                value={formData.comune}
                                onChange={handleChange}
                                required
                                aria-required="true"
                            />
                          </div>
                          <div className="form-group col-md-2 cols-sm-6 mb_20">
                            <label htmlFor="cap">CAP <b className="text text-danger">*</b>:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cap"
                                name="cap"
                                value={formData.cap}
                                onChange={handleChange}
                                required
                                aria-required="true"
                            />
                        </div>                        
                      </div>
                      <div className="row justify-content-center">
                        <div className="form-group col-md-6 col-sm-12 mb_20">
                          <label htmlFor="testo">
                            Data e luogo del funerale:
                          </label>
                          <textarea 
                            className="form-control" 
                            id="funerale" 
                            name="funerale" 
                            value={formData.funerale} 
                            onChange={handleChange}                         
                          />
                        </div>
                        <div className="form-group col-md-6 col-sm-12 mb_20">
                          <label htmlFor="testo">
                            Ubicazione del Cimitero:
                          </label>
                          <textarea 
                            className="form-control" 
                            id="cimitero" 
                            name="cimitero" 
                            value={formData.cimitero} 
                            onChange={handleChange}                         
                          />
                        </div>
                      </div>
                      <div className="row justify-content-center"> {/* Aggiunto row per centrare */}
                        <div className="form-group col-sm-12 col-md-8 col-lg-6 mb_30"> 
                          <label htmlFor="testo">
                            Testo libero <i className="text text-danger">(max 1000 caratteri)</i>:
                          </label>
                          <textarea
                            className="form-control"
                            id="testo"
                            name="testo"
                            value={formData.testo || ""} // Usa formData.testo
                            onChange={handleChange}
                            required
                            aria-required="true"
                            rows="6"
                            // maxLength={maxChars} // Il controllo logico è in handleChange.
                                                    // Puoi lasciarlo per il feedback nativo del browser se preferisci,
                                                    // ma la nostra logica in handleChange previene l'aggiornamento dello stato.
                          />
                          <div>
                            Caratteri inseriti: {(formData.testo || "").length} / {maxChars}
                          </div>
                          <div>
                            Caratteri rimanenti: {maxChars - (formData.testo || "").length}
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="form-group col-md-12 mb_20">
                              {/* Modulo di caricamento dell'immagine */}
                              <div className='row mb_20'>
                                <div className="col-lg-4 col-md-2 col-sm-3 col-xs-1"></div>
                                <div className='col-lg-4 col-md-8 col-sm-6 col-xs-10 alert alert-warning'>
                                  <h4 className="text text-danger mb_20">Tutti i campi sono obbligatori</h4>
                                  <h3>ATTENZIONE:</h3>
                                  Non sono consentiti file non rispondenti ai seguenti requisiti:
                                  <ul>
                                    <li> &nbsp; a) Dimensioni: <b>non</b> superiori a <b>2 MegaBytes</b></li>
                                    <li> &nbsp; b) Formato: <b>.JPG/.JPEG</b> o <b>.PNG</b></li>
                                    <li> &nbsp; c) Dimensioni massime: <b>1920 x 1280 px</b>, 72 dpi</li>
                                    <li> &nbsp; d) &Eacute; possibile inserire il medesimo manifesto/anniversario in massimo 2 Comuni/CAP</li>
                                    <li> &nbsp; e) Sono consentiti al massimo 2 manifesti/anniversari per ogni codice fiscale; i Visitatori ed il ns. staff verificheranno la correttezza delle informazioni inserite ed in caso di mancato riscontro l'annuncio verrà eliminato.</li>
                                    
                                  </ul>
                                </div>
                              </div>
                              <div className="row justify-content-center mb-20">
                                <div className="col-lg-3 col-md-2 col-sm-3 col-xs-1 mb-20"></div>
                                  <div className='col-lg-6 col-md-8 col-sm-6 col-xs-10'>
                                    <div className="input-group mb-3">
                                      <label className="form-label" htmlFor="file">Scegli il file dal tuo device <b className="text text-danger">*</b>:
                                        <input type="file" className="form-control" name="file" id="file" onChange={handleFileChange} required aria-required="true" />
                                      </label>
                                    </div>
                                    {fileError && (
                                      <p style={{fontWeight: "500", color: "#CC0000"}}>{fileError} Puoi <a href='https://www.iloveimg.com/it/comprimere-immagine' target='_blank' style={{color: '#4c267b', fontWeight: '700'}}>comprimere qui il tuo file</a></p>
                                    )}
                                </div>
                              </div>
                        </div>                      
                      
                        <div className="form-group col-md-8 col-sm-12 mb_20" style={{textAlign: 'right'}}>
                            {showSuccessMessage && ( // Mostra il messaggio solo se showSuccessMessage è true
                                <div className="alert alert-success mt_20" role="alert">Pubblicato con successo!</div>
                            )}
                            <button type="submit" className="btn btn-primary mt_20" disabled={codiceFiscaleCount >= 2 || fileError}> {/* Disabilita il pulsante se il codice fiscale è presente 2 o più volte o il file non rispetta le regole indicate */}
                                Salva
                            </button>
                        </div>
                      </div>
                    </div>
                  </form>                
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default NuovoAnnuncio;